import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComposableBankingComponent } from './composable-banking.component';

const routes: Routes = [
  {
    path: '',
    component: ComposableBankingComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComposableBankingRoutingModule { }
